export const MENU_SPINNER = 'MENU_SPINNER'
export const MENU_SET_DATA = 'MENU_SET_DATA'
export const MENU_SEND_REQUEST = 'MENU_SEND_REQUEST'
